import React, { Component } from "react";

import Modal from "react-modal";
import Media from "../media/media";

import VideoPlayer from "../../../video_player";

import RecommendationLink from "../../../recommendation/recommendation_interface/recommendation_link";
class ModalMedia extends Component {
  state = {};

  componentWillMount() {
    Modal.setAppElement("body");
  }

  render() {
    if (this.props.open === false) {
      return <React.Fragment />;
    }
    return (
      <Modal className="follow-views" isOpen={this.props.open}>
        <div className="follow-return" onClick={this.handleCloseView} />
        <div
          className="follow-view modal-media center media_v2 max_width_500"
          style={{ maxWidth: "484px" }}
        >
          <div style={{ position: "relative" }}>{this.renderMedia()}</div>
          <RecommendationLink recommendation={this.props.answer} />
        </div>
      </Modal>
    );
  }

  renderMedia() {
    if (this.props.answer.answer_type === "video") {
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        muted: false,
        loop: true,
        playsInline: true,
        height: window.height,
        sources: [
          {
            src: this.props.answer.video_url_original
          }
        ]
      };
      return (
        <VideoPlayer
          {...videoJsOptions}
          recommendation={this.props.answer}
          windowHeight={"100%"}
        />
      );
    } else {
      return <Media answer={this.props.answer} openMedia={true} />;
    }
  }

  handleCloseView = event => {
    this.props.handleCloseView();
  };
}

export default ModalMedia;



// WEBPACK FOOTER //
// ./src/components/list/interface/modal/modal_media.jsx